import { checkDriverIsExists, checkDriverIsExistsByEdit } from '../../../../../../../api/register/driver.js'
import { identityVerify, phoneVerify, driverLicenseVerify } from '../../../../../../../constant/formRegular.js'
import rules from '../addOrEditDialogRule.js'
import { cloneDeep } from 'lodash'
// 表单数据
export const formData = {
    driverCode: '', // 司机编码
    driverName: '', // 司机名称
    driverStatus: '', // 司机状态
    phoneNo: '', // 手机号码
    blackFlag: '', // 是否列入黑名单
    identificationFlag: '',

    countryCode: '', // 国家编码
    countryName: '', // 国家名称
    provinceCode: '', // 省份编码
    provinceName: '', // 省份名称
    cityCode: '', // 城市编码
    cityName: '', // 城市名称
    district: '', // 地区
    familyAddress: '', // 详细地址

    idCardFileId: '', // 身份证正面文件id
    idCardFileName: '', // 身份证正面文件名称
    idCardFileUrl: '', // 身份证正面文件url
    idCardBottomSideFileName: '', // 身份证反面文件名称
    idCardBottomSideFileUrl: '', // 身份证反面文件url
    idCardBottomSideFileId: '', // 身份证反面文件id
    idCard: '', // 身份证号
    idCardStartDate: '', // 身份证起始日期
    idCardEndDate: '', // 身份证结束日期

    drivingLicenceFileId: '', // 驾驶证文件id
    drivingLicenceFileName: '', // 驾驶证文件名称
    drivingLicenceFileUrl: '', // 驾驶证文件url
    driveType: '', // 准驾车型
    drivingLicence: '', // 驾驶证号
    driveStartDate: '', // 驾驶证起始日期
    driveEndDate: '', // 驾驶证结束日期

    delegateFileId: '', // 委派函文件id
    delegateFileName: '', // 委派函文件名称
    delegateFileUrl: '', // 委派函文件url
    delegateStartTime: '', // 委派函起始日期
    delegateEndTime: '', // 委派函结束日期
    pushType: '', // 签署方式

    birthday: '', // 出生日期(身份证)
    people: '', // 民族(身份证)
    authorityIssue: '', // 签发机关(身份证)
    mainNationality: '', // 国籍(驾驶证)
    dateIssue: '', // 初次领证日期(驾驶证)
    empCertificate: '', // 从业资格证号
    empCertificateFileId: '', // 从业资格证文件id
    empCertificateFileName: '', // 从业资格证文件名称
    empCertificateFileUrl: '', // 从业资格证文件url
    empCertificateEndDate: '', // 从业资格证到期日期
    driverLicenseAuthority: '', // 签发机关（驾驶证）
    onWayContactCategory: '', // 在途联系类别
    onWayContactName: '', // 在途联系人
    onWayContactPhone: '', // 在途联系人手机
    stamperName: '', // 签署人姓名
    stamperCode: '', // 签署人编码
    stamperMobile: '', // 签署人手机号码
    delegateOnline: '1', // 委派函类型(0 == 线下  1 == 线上)
    empCertificateType: '', // 从业资格类别
}

// 表单字段校验规则
export const formRules = ctx => {
    // 身份证件到期日期校验规则
    const idEffectiveDate = (rule, value, callback) => {
        // 身份证有效期校验
        const idStartDate = new Date(ctx.formData.idCardStartDate).getTime() // 获取身份证生效时间戳
        const timestamp = new Date(value).getTime() // 获取的截止时间戳
        const time = new Date().getTime() // 获取的当前时间
        if (timestamp - time <= 0) {
            callback(new Error('身份证必须大于当前时间'))
        } else if (timestamp - idStartDate <= 0) {
            callback(new Error('身份证必须大于起始日期'))
        } else {
            callback()
        }
    }
    // 驾驶证件到期日期校验规则
    const driveEffectiveDate = (rule, value, callback) => {
        // 驾驶证有效期校验
        const driveStartDate = new Date(ctx.formData.driveStartDate).getTime() // 获取驾驶证生效时间戳
        const timestamp = new Date(value).getTime() // 获取的截止时间戳
        const time = new Date().getTime() // 获取的当前时间
        if (timestamp - time <= 0) {
            callback(new Error('驾驶证到期日期必须大于当前时间'))
        } else if (timestamp - driveStartDate <= 0) {
            callback(new Error('驾驶证到期日期必须大于起始日期'))
        } else {
            callback()
        }
    }
    const drivingNoRule = (rule, value, callback) => {
        if (ctx.formData.idCard !== value) {
            callback(new Error('驾驶证与身份证号码需要一致'))
        } else {
            callback()
        }
    }
    // const phoneOccupied = (rule, value, callback) => {
    //     if (ctx.formData.idCard && phoneVerify.test(value)) {
    //         // console.log('driverCode', ctx.formData.driverCode)
    //         const checkReq = ctx.formData.driverCode ? checkDriverIsExistsByEdit : checkDriverIsExists
    //         checkReq({ idCard: ctx.formData.idCard, phoneNo: value, driverCode: ctx.formData.driverCode }).then(res => {
    //             if (res && +res.code === 0) {
    //                 res.data ? callback(new Error(res.msg)) : callback()
    //                 // callback()
    //             }
    //         }).catch(err => {})
    //     } else { callback(); }
    // };

    return {
        // 身份证号
        idCard: [
            { required: true, message: '请输入身份证号', trigger: ['blur', 'change'] },
            { pattern: identityVerify, message: '请输入正确格式的身份证', trigger: ['blur', 'change'] },
        ],
        // 手机号码
        phoneNo: [
            { required: true, message: '请输入手机号码', trigger: ['blur', 'change'] },
            { pattern: phoneVerify, message: '请输入正确格式的手机号码', trigger: ['blur', 'change'] },
            // { validator: phoneOccupied, trigger: ['blur'] },
        ],
        idCardStartDate: [{ required: false, message: '请选择身份证件有效期', trigger: ['change'] }],
        // 身份证件到期日期
        idCardEndDate: [
            { required: true, message: '请选择身份证件有效期', trigger: ['change'] },
            { validator: idEffectiveDate, trigger: ['change'] },
        ],
        // 驾驶证件到期日期
        driveEndDate: [
            { required: true, message: '请选择驾驶证件有效期', trigger: ['change'] },
            { validator: driveEffectiveDate, trigger: ['change'] },
        ],
        countryCode: [{ required: false, message: '请选择国家', trigger: ['blur', 'change'] }],
        provinceCode: [{ required: false, message: '请选择省份', trigger: ['blur', 'change'] }],
        cityCode: [{ required: false, message: '请选择城市', trigger: ['blur', 'change'] }],
        familyAddress: [{ required: false, message: '请输入详细地址', trigger: ['blur', 'change'] }],
        drivingLicence: [
            { required: true, message: '请输入驾驶证号', trigger: ['blur', 'change'] },
            { pattern: driverLicenseVerify, message: '请输入正确格式的驾驶证号', trigger: ['blur', 'change'] },
            { validator: drivingNoRule, trigger: ['blur', 'change'] },
        ],
        ...cloneDeep(rules), // 因为rules里面规则都是数组，需要使用深拷贝避免影响
    }
}

// 委派函类型(0 == 线下  1 == 线上)
export const DELEGATE_TYPE = {
    OFFLINE: '0',
    ONLINE: '1',
}

export const stamperParams = {
    name: '签署人',
    value: 'stamperName',
    width: '950px',
    method: 'post',
    unfold: true,
    advanceConfig: [
        { prop: 'stamperName', value: '签署人姓名' },
        { prop: 'stamperCode', value: '签署人编码' },
        { prop: 'stamperMobile', value: '手机号码' },
    ],
    tableConfig: [
        { prop: 'stamperCode', value: '签署人编码' },
        { prop: 'stamperName', value: '签署人姓名' },
        { prop: 'stamperMobile', value: '手机号码' },
    ],
    advanceUrl: '/supplierStamperInfos',
    type: 'advance',
    prefix: '/api-srm-web/supplier',
    cbParams: ['stamperCode', 'stamperName', 'stamperMobile'],
}
